import React, { useMemo } from 'react';
import { CroppedImageView } from '@bingads-webui-campaign-react/cropped-image-view';

export const DisplayAdPreview = ({ ad }) => {
  const resizeImageHeightForThumbnail = useMemo(() => {
    if (ad && ad.image && ad.image.cropHeight && ad.image.cropWidth) {
      const aspectRatio = ad.image.cropWidth / ad.image.cropHeight;
      const maxWidth = 360;
      return Math.min(maxWidth / aspectRatio, 220);
    }
    return 0;
  }, [ad]);

  return (
    <CroppedImageView
      src={ad.image.src}
      originalWidth={ad.image.originalWidth}
      aspectRatio={ad.image.cropWidth / ad.image.cropHeight}
      resizeImageHeight={resizeImageHeightForThumbnail}
      SourceWidth={ad.image.cropWidth}
      SourceX={ad.image.cropX}
      SourceY={ad.image.cropY}
    />
  );
};
